import { Disclosure } from '@headlessui/react';
import Down from 'assets/icons/Down';
import Trash from 'assets/icons/Trash';
import Up from 'assets/icons/Up';
import Chip from 'common/components/Chip';
import useTranslation from 'common/hooks/useTranslation';
import {
  hasChoices,
  isChoiceBasedType,
  isMultipleChoice,
} from 'offers/utils/questionUtils';
import React from 'react';

export const OfferQuestionItem = ({
  name,
  description,
  dataType,
  choices = [],
  isSingleAnswer,
  answer,
  isRemovable,
  onDeleteClick,
}) => {
  const { t } = useTranslation('offers\\index');
  const choiceBased = isChoiceBasedType(dataType);
  const hasChoicesAvailable = hasChoices(choices);
  const isMultipleChoiceFlag = isMultipleChoice(dataType);

  return (
    <Disclosure defaultOpen={true}>
      {({ open }) => (
        <div className='py-2'>
          <Disclosure.Button className='flex w-full text-left'>
            <span className='w-full text-sm font-semibold'>{name}</span>
            {open ? <Up /> : <Down />}
            {isRemovable && (
              <span onClick={onDeleteClick}>
                <Trash />
              </span>
            )}
          </Disclosure.Button>
          <Disclosure.Panel className='flex flex-col text-xs font-normal pl-4 gap-y-2'>
            <div className='flex flex-row gap-1 w-full'>
              <span className='font-semibold w-1/6'>{t('description')}</span>
              <span className='w-full mr-auto pr-2'>
                {description ? description : t('no-description')}
              </span>
            </div>
            <div className='flex flex-row gap-1 w-full'>
              <span className='font-semibold w-1/6'>{t('dataType')}</span>
              <div className='w-full mr-auto pr-2'>
                <span className='w-full mr-auto pr-2'>{t(dataType)}</span>
              </div>
            </div>
            {choiceBased && hasChoicesAvailable && (
              <>
                {isMultipleChoiceFlag && (
                  <div className='flex flex-row gap-1 w-full'>
                    <span className='font-semibold w-1/6'>
                      {t('selection-type')}
                    </span>
                    <span className='w-full mr-auto pr-2'>
                      <Chip
                        variant={isSingleAnswer ? 'success' : 'primary'}
                        className='p-0 px-2'
                      >
                        {t(isSingleAnswer ? 'singleAnswer' : 'multipleAnswers')}
                      </Chip>
                    </span>
                  </div>
                )}
                <div className='flex flex-row gap-1 w-full'>
                  <span className='font-semibold w-1/6'>{t('choices')}</span>
                  <div className='w-full flex flex-wrap gap-1'>
                    {choices.map((choice, index) => (
                      <Chip key={index} variant='grey' className='p-0 px-2'>
                        {choice}
                      </Chip>
                    ))}
                  </div>
                </div>
              </>
            )}
            {/*Uncomment this when the questions modal starts to accept answers*/}
            {/*<div className="flex flex-row gap-1 w-full">*/}
            {/*  <span className="font-semibold w-1/6g">{t('answer')}</span><span*/}
            {/*  className="w-full mr-auto pr-2">{answer}</span>*/}
            {/*</div>*/}
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};
